<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div
      class="flex gap-2 w-full bg-white items-center"
      [formGroup]="searchForm"
    >
      <img src="../../assets/image/search.svg" alt="" class="" />

      <input
        placeholder="Search Here..."
        formControlName="searchText"
        class="w-full border p-2 rounded-md outline-none"
      /><span>From:</span>
      <div class="flex gap-2 border p-2 rounded-xl">
        <input
          type="date"
          placeholder="from"
          class="outline-none"
          formControlName="fromDate"
          [max]="cValue"
        />
      </div>
      <span>To:</span>
      <div class="flex gap-2 border p-2 rounded-xl">
        <input
          type="date"
          placeholder="from"
          class="outline-none"
          formControlName="toDate"
          
          [min]="searchForm.controls['fromDate'].value"
        />
      </div>
      <!-- <select class="w-80 border p-2 rounded-xl" formControlName="typeId">
        <option>Agent ID</option>
        <option>Parent ID</option>
      </select> -->
      <div class="flex justify-end gap-4 p-2">
        <app-primary-button (click)="searchApiLogs()"
          >Search</app-primary-button
        >
        <!-- <app-primary-button>View</app-primary-button>
        <app-primary-button>Download</app-primary-button> -->
      </div>
    </div>
  </div>
  <div
    class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-hidden"
  >
    <table class="w-[100%] text-left h-full overflow-y-auto">
      <tr class="h-8">
        <th class="w-12">ID</th>
        <th class="w-48">Transaction ID</th>
        <th class="w-40">Created Date</th>
        <th class="w-40">Updated Date</th>
      </tr>
      <tr
        *ngFor="let item of apiLogsData; let i = index"
        class="h-8"
        [ngStyle]="{
          backgroundColor:
            i % 2 == 0
              ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
              : 'white'
        }"
      >
        <td>{{ item._id }}</td>

        <td class="pl-3">{{ item.logDetail["x-amzn-trace-id"] }}</td>
        <td>{{ item.createdAt | date : "dd/MM/yyyy" }}</td>
        <td>{{ item.updatedAt | date : "dd/MM/yyyy" }}</td>
      </tr>
    </table>
    <app-next-preview-button
      [limit]="pagination.limit"
      [currentPage]="pagination.currentPage"
      [totalPage]="totalPage"
      [totalRecords]="totalRecords"
      (next)="nextPage()"
      (last)="onLast()"
      (first)="onFirst()"
      (previous)="previousPage()"
      (pageChange)="onPageChange($event)"
    >
    </app-next-preview-button>
  </div>
</div>
